import { DataSource, HorizontalSpacer, Label, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutRmisControl extends Layout {
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    horizontalspacer3: HorizontalSpacer;
    labelOnboarding: Label;
    labelSFTPServer: Label;
    panel2: Panel;
    panelServer: Panel;
    panelSftp: Panel;
    sourceCarrierInsControl: DataSource;
    switchAutoAdd: Switch;
    switchAutoApproveCarriers: Switch;
    switchEnableAdvances: Switch;
    switchIsActive: Switch;
    switchMonitorCarriers: Switch;
    switchSendCarriers: Switch;
    textboxCarrierAgreement: Textbox;
    textboxCarrierStatus: Textbox;
    textboxDeltaRetrieval: Textbox;
    textboxErrorEmail: Textbox;
    textboxFtpPassword: Textbox;
    textboxFtpUserId: Textbox;
    textboxLastOnboardingCheck: Textbox;
    textboxOnboardingServer: Textbox;
    textboxPacketUrl: Textbox;
    textboxPacketWebsiteUrl: Textbox;
    textboxPassword: Textbox;
    textboxPort: Textbox;
    textboxRemoteDirectory: Textbox;
    textboxServer: Textbox;
    textboxSftpServer: Textbox;
    textboxUnloadFile: Textbox;
    textboxUserId: Textbox;
}
